import TextEffectLines from "./Text/TextEffectLines";
export default function SectionBanner() {
  return (
    <main className="grid min-h-full place-items-center px-6 py-24 sm:py-30 lg:px-8">
      <div
        className="text-center"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1000"
      >
        {/* <p className="text-base font-semibold text-indigo-600">inging</p> */}
        <h1 className="mt-4 text-5xl font-bold tracking-tight text-white">
          Planning, Design, and Frontend Expertise
        </h1>
        <TextEffectLines
          title={
            "기획, 디자인, 프론트엔드 개발을 모두 경험한 강점을 활용해 사용성과 심미성을 동시에 고려한 결과물을 만들어냅니다."
          }
        />
      </div>
    </main>
  );
}
